import StaffStatusService from '@/services/StaffStatusService';

export const namespaced = true;

export const state = {
  staffStatuses: []
};

export const mutations = {
  setStaffStatuses(state, staffStatuses) {
    state.staffStatuses = staffStatuses;
  }
};

export const actions = {
  async getStaffStatuses({ commit }) {
    try {
      const response = await StaffStatusService.getStaffStatuses();
      commit('setStaffStatuses', response.data.data);
    } catch (error) {
      // handle error as needed
      commit('setStaffStatuses', []);
    }
  }
};

export const getters = {
  staffStatuses: state => state.staffStatuses
};
